import React from 'react';
import s from './SiteWide.styles';
const SiteWide = ({ children, className, width = 'default', id }) => {
    return (React.createElement(s.Container, { id: id, className: className, width: width }, children));
};
export default SiteWide;
